export default __webpack_public_path__ + "static/media/Punto_11_Palazzi_dell_800_ENG_Def.3028fc6f.aac";